import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { jsx as _jsx } from "react/jsx-runtime";
export const BadgeAI = props => /*#__PURE__*/_jsx(AIBadge, Object.assign({}, props));